import * as types from "../constants/ActionTypes";
import * as apiConstants from "../constants/Api";
import { parseInitials } from "../utils/initials";

export const initialState = {
  loading: true,
  doReload: undefined
};

function user(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_USER_RECEIVED:
      const { user } = action;
      return {
        ...state,
        loading: false,
        fullName: user.name,
        firstName: user.name.split(" ")[0],
        initials: parseInitials(user.name),
        email: user.email,
        id: user.id,
        profilePicture: user.profilePicture,
        isAdmin: user.userType === apiConstants.ADMIN_USER_TYPE,
        assumedBy: !!user.assumedBy,
        assumedByAdmin: user.assumedBy === apiConstants.ADMIN,
        assumedBySuperadmin: user.assumedBy === apiConstants.SUPERADMIN,
        assumedBySandbox: user.assumedBy === apiConstants.SANDBOX,
        currentLanguageLocale: user.locale || "en",
        company: {
          cookieManagementEnabled: user?.company?.cookieManagementEnabled
        }
      };
    default:
      return state;
  }
}

export default user;
